import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from 'api/Api';
import { authApi } from 'api/AuthApi';

export interface OrganizationInvite {
  id: string;
  userEmail: string;
  userName: string;
  tenantOrganization: {
    name: string;
  };
}

export const organizationInvitesApi = createApi({
  baseQuery: baseQueryWithReAuth,
  reducerPath: 'organizationInvitesApi',
  tagTypes: ['OrganizationInvites'],
  endpoints: (build) => ({
    getAllOrganizationInvites: build.query<OrganizationInvite[], void>({
      query: () => ({ url: `/organization-invites` }),
      transformResponse: (response: { data: OrganizationInvite[] }) => response.data,
      providesTags: () => ['OrganizationInvites']
    }),
    acceptOrganizationInvite: build.mutation<void, Pick<OrganizationInvite, 'id'>>({
      query: ({ id }) => ({
        url: `/organization-invites/${id}/accept`,
        method: 'POST'
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(authApi.util.invalidateTags(['Auth']));
        } catch (_) {
          // no-op: auth invalidation should only happen on successful accept
        }
      },
      invalidatesTags: () => ['OrganizationInvites']
    }),
    declineOrganizationInvite: build.mutation<void, Pick<OrganizationInvite, 'id'>>({
      query: ({ id }) => ({
        url: `/organization-invites/${id}/decline`,
        method: 'POST'
      }),
      invalidatesTags: () => ['OrganizationInvites']
    })
  })
});

export const {
  useGetAllOrganizationInvitesQuery,
  useAcceptOrganizationInviteMutation,
  useDeclineOrganizationInviteMutation
} = organizationInvitesApi;
